import { useState } from 'react';
import { tickerTags } from '@/mocks/home';

const navLinks = [
  { label: '实时快讯', href: '#flash' },
  { label: '合集索引', href: '#collections' },
  { label: '讨论区', href: '#topics' },
  { label: '瓜友群', href: '#community' },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      {/* 运营顶条 */}
      <div className="bg-primary-950 text-background-100">
        <div className="mx-auto flex h-8 max-w-[1280px] items-center justify-between gap-4 px-4 text-[11px] tracking-wide md:px-6">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulseDot" />
              实时更新中
            </span>
            <span className="hidden text-background-400 sm:inline">VOL.128 · 2026.10.10</span>
          </div>
          <div className="hidden items-center gap-4 text-background-300 md:flex">
            <a href="#community" className="cursor-pointer transition-colors hover:text-background-50">投稿爆料</a>
            <span className="h-3 w-px bg-background-50/20" />
            <a href="#collections" className="cursor-pointer transition-colors hover:text-background-50">合集总览</a>
          </div>
        </div>
      </div>

      {/* 跑马灯 */}
      <div className="overflow-hidden border-b border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-[1280px] items-center gap-4 px-4 md:px-6">
          <span className="hidden shrink-0 items-center gap-1.5 py-2 font-label text-[11px] font-medium tracking-widest text-primary-700 md:flex">
            <i className="ri-flashlight-fill" />
            今日索引
          </span>
          <div className="relative flex-1 overflow-hidden py-2">
            <div className="flex w-max animate-marquee items-center gap-8">
              {[...tickerTags, ...tickerTags].map((tag, i) => (
                <span key={`${tag}-${i}`} className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-600">
                  <span className="h-1 w-1 rounded-full bg-secondary-500" />
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 主栏 */}
      <div className="border-b border-background-200 bg-background-50/90 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between gap-6 px-4 md:h-[72px] md:px-6">
          <a href="#top" className="flex cursor-pointer items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">黑料吃瓜</span>
              <span className="mt-1 font-label text-[9px] tracking-[0.3em] text-foreground-500">GOSSIP&nbsp;WEEKLY</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer rounded-md px-4 py-2 font-label text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#community"
              className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
            >
              <i className="ri-group-line" />
              加入瓜友群
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
            <div className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer rounded-md px-3 py-3 font-label text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#community"
                onClick={() => setMenuOpen(false)}
                className="mt-2 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 font-label text-sm font-medium text-background-50"
              >
                <i className="ri-group-line" />
                加入瓜友群
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}